import { render, staticRenderFns } from "./payment-methods2.vue?vue&type=template&id=6b4f429a&scoped=true"
import script from "./payment-methods2.vue?vue&type=script&lang=js"
export * from "./payment-methods2.vue?vue&type=script&lang=js"
import style0 from "./payment-methods2.vue?vue&type=style&index=0&id=6b4f429a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f429a",
  null
  
)

export default component.exports